module.exports = __webpack_public_path__ + "21b21f02e144d1e551bc652b5970b891.svg";